import React from 'react';
import { ChatCardStyles } from '../../styles';
import { Card, CardContent, Typography, Box, withStyles, WithStyles } from '@material-ui/core';
import { IGuia } from '../../interface';
import { isMobile } from '../../functions';
import { Link } from 'react-router-dom';

interface ChatCardProp extends WithStyles<typeof ChatCardStyles> {
  guia:IGuia;
  notificaciones:number;
  children?: React.ReactNode;
  className?: string;
}


const CardComponent = (props:ChatCardProp) => 
<Card className={props.classes.root}>
  <CardContent className={props.classes.content}>
    <Box>
      <Box display="flex" justifyContent="space-between">
        <Box color="white" fontSize="13px">
        Guia: {props.guia.guia}
        </Box>
        <Box color="white" fontSize="10px">
          justo ahora
        </Box>
      </Box>
    </Box>
    <div className={props.classes.circulo}>
        <Box fontSize="17px" color="black">{props.guia.estado==='FINALIZADO' ? 0 : props.notificaciones}</Box>
    </div>
    <Typography component="div">
      <Box color="white" fontSize="10px">
        Remitente: {props.guia.nombre_remitente}
      </Box>
      <Box color="white" fontSize="10px">
        Direccion destinatario: {props.guia.direccion_destinatario}
      </Box>
      <Box color="white" fontSize="10px">
        Destinatario: {props.guia.nombre_destinatario}
      </Box>
    </Typography>
  </CardContent>
</Card>

const ChatCardComponent = (props:ChatCardProp): JSX.Element => {
  console.log("========NOTIFICACIONES===========");
  console.log(props.notificaciones);
  console.log("========NOTIFICACIONES===========");
  return (
    isMobile() ? 
    <Link to={`/chat`} className={props.classes.link}>
      <CardComponent {...props}/>
    </Link>
    :
    <CardComponent {...props}/>
  )
}


export const ChatCard = withStyles(ChatCardStyles)(ChatCardComponent)